import { ButtonLink } from 'braid-design-system';

import Routes from 'src/config/routes';
import { createDotNetLinkUrl } from 'src/utils';

const AlphabetLinks = () => {
  const alphaList = 'abcdefghijklmnopqrstuvwxyz'.split('');
  alphaList.splice(0, 0, '0-9');

  return alphaList.map((letter, index) => (
    <ButtonLink
      key={index}
      size="small"
      variant="soft"
      href={createDotNetLinkUrl(
        `${Routes.FRANCHISE_DIRECTORY}${letter.toLowerCase()}`,
      )}
    >
      {letter.toUpperCase()}
    </ButtonLink>
  ));
};

export default AlphabetLinks;
